<template>
  <div class="load-animation bg-white">
    <div class="traditional"></div>
  </div>
</template>

<style lang="css">
@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg); } }

@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg); } }

.load-animation {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
/**
  * Traditional
  *
  * @author jh3y
*/

.traditional {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 50px;
  width: 50px;
  height: 50px;
}

.traditional:before {
  -webkit-animation: spin .5s infinite linear;
  animation: spin .5s infinite linear;
  border-radius: 100%;
  -webkit-box-shadow: inset -2px 0 0 0px var(--bs-primary);
  box-shadow: inset -2px 0 0 0px var(--bs-primary);
  content: '';
  height: 50px;
  position: absolute;
  width: 50px; }
</style>